(function ($) {
	"use strict";

	$(function () {
		$(".collapse").click(function () {
			var cat = $(this);

			if (cat.siblings(".materieel-overview").length === 0) {
				return;
			}

			if (cat.parent().hasClass("open")) {
				closeCategory(cat);
			} else {
				openCategory(cat);
			}

			var catIds = [];
			$(".category-dropdown ul.list-group li.open").each(function () {
				catIds.push($(this).data("category-id"));
			});

			Cookies.set("open-category-ids", catIds);
		});
	});

	$(function () {
		var categoryidsString = Cookies.get("open-category-ids");

		if (typeof (categoryidsString) === "undefined") {
			return;
		}

		var categoryids = JSON.parse(categoryidsString);

		$.each(categoryids, function (index, value) {
			var cat = $(".category-dropdown ul.list-group li[data-category-id=" + value + "] .collapse");
			openCategory(cat);
		});
	});

	function openCategory(cat) {
		var subMenu = cat.siblings(".materieel-overview");
		var arrow = cat.find(".fa");
		subMenu.show();
		arrow.addClass("fa-angle-up");
		arrow.removeClass("fa-angle-down");
		cat.parent().addClass("open");
	}

	function closeCategory(cat) {
		var subMenu = cat.siblings(".materieel-overview");
		var arrow = cat.find(".fa");
		subMenu.hide();
		arrow.removeClass("fa-angle-up");
		arrow.addClass("fa-angle-down");
		cat.parent().removeClass("open");
	}
})(jQuery);
